module.exports = __webpack_public_path__ + "b0b7cb5229e6a3d4b2d97c7289b183a4.png";